export const COMPANY = {
  EVO: 'EVO',
  RS: 'RS',
  HK: 'HK',
  NHK: 'NHK',
  FR: 'FR',
  SG: 'SG',
  ST: 'ST',
  CN: 'CN',
  CNC: 'CNC',
  UK: 'UK',
  JP: 'JP',
  US: 'US'
}

export const companies = [
  {
    text: 'general_business_keyword.operation_center.evo',
    value: COMPANY.EVO
  },
  {
    text: 'general_business_keyword.operation_center.rs',
    value: COMPANY.RS
  },
  {
    text: 'general_business_keyword.operation_center.hk',
    value: COMPANY.HK
  },
  {
    text: 'general_business_keyword.operation_center.nhk',
    value: COMPANY.NHK
  },
  {
    text: 'general_business_keyword.operation_center.fr',
    value: COMPANY.FR
  },
  {
    text: 'general_business_keyword.operation_center.sg',
    value: COMPANY.SG
  },
  {
    text: 'general_business_keyword.operation_center.st',
    value: COMPANY.ST
  },
  {
    text: 'general_business_keyword.operation_center.cn',
    value: COMPANY.CN
  },
  {
    text: 'general_business_keyword.operation_center.cnc',
    value: COMPANY.CNC
  },
  {
    text: 'general_business_keyword.operation_center.uk',
    value: COMPANY.UK
  },
  {
    text: 'general_business_keyword.operation_center.jp',
    value: COMPANY.JP
  },
  {
    text: 'general_business_keyword.operation_center.us',
    value: COMPANY.US
  }
]